import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './bottom-footer.css'

const BottomFooter = ({ mobileAppNav = false }) => {
    const location = useLocation();
    const navItems = [
        { label: "Home", icon: "ph ph-house", to: "/home" },
        { label: "Orders", icon: "ph ph-package", to: "/orders" },
        { label: "Cart", icon: "ph ph-shopping-cart-simple", to: "/cart" },
        { label: "Setting", icon: "ph ph-user-circle", to: "/my-account" },
    ];

    return (
        <div className={`bottom-footer bg-black${mobileAppNav ? " rghtnow-home-bottom-footer" : ""}`}>
            <div className="container container-lg">
                <div className="bottom-footer__inner flex-wrap gap-16 py-8">
                    <p className="text-center text-white">
                        RGHT NOW © 2026. All Rights Reserved{" "}
                    </p>
                   {/* <div className="flex-align gap-8 flex-wrap">
                        <span className="text-heading text-sm">We Are Acepting</span>
                        <img src="assets/images/thumbs/payment-method.png" alt="" />
                    </div>*/}
                </div>
            </div>
            {mobileAppNav && (
                <nav className="rghtnow-bottom-nav" aria-label="Mobile navigation">
                    {navItems.map((item) => {
                        const isActive = location.pathname === item.to;

                        return (
                            <Link
                                className={`rghtnow-bottom-nav__item ${isActive ? "active" : ""}`}
                                to={item.to}
                                key={item.label}
                            >
                                <i className={item.icon} />
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>
            )}
        </div>

    )
}

export default BottomFooter
